import { KitbagFootballProvider } from '@statsbomb/kitbag-global-football';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import env from '@/env';
import { useShouldShowAlphaTestingFeature, useShouldShowDevTeamFeature } from '@/hooks/featureFlags';

export const KitbagGlobalFootballProvider = ({ children }: { children: ReactNode }) => {
  const { i18n } = useTranslation();
  const enableDevTeamFeatures = useShouldShowDevTeamFeature();
  const enableAlphaTestFeatures = useShouldShowAlphaTestingFeature();
  return (
    <KitbagFootballProvider
      baseUrl={env.VITE_PARACHUTE_REST_API_ENDPOINT}
      gslBaseUrl={env.VITE_HUDL_URL}
      translations={i18n.getResourceBundle(i18n.language, 'kitbagGlobalFootball')}
      enableDevTeamFeatures={enableDevTeamFeatures}
      enableAlphaTestFeatures={enableAlphaTestFeatures}
    >
      {children}
    </KitbagFootballProvider>
  );
};
